//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {formatDate} from '../../../src/lib/date';
import util from '@/lib/util';

export default {
    name: "activeApply",
    components: {},
    filters: {
        // formatDate(time, type) {
        //     var date = new Date(time);
        //     if (type == 1) {
        //         return formatDate(date, 'yyyy-MM-dd');
        //     }
        //     return formatDate(date, 'yyyy-MM-dd hh:mm');
        // }
    },
    data() {
        return {
            id: 0,
            activity: {},
            downloadUrl: util.ApiUrl + '/file/download/',
            currrentMemberPoint: 0
        };
    },
    methods: {
        getActiveDetail() {
            abp.ajax.get('/api/services/app/Activity/GetActivityById?id=' + this.id).then((res) => {
                this.activity = res.data.result;
                console.log(res.data.result);

            }).finally(() => {

            });
        },
        saveSignUp() {
            var p = 0;
            if (this.activity.isSignUp && this.activity.signUpCost > 0) {
                p = this.activity.signUpCost;
            }
            this.$router.push({
                name: 'activeForm',
                params: {
                    id: this.id,
                    price: p
                }
            })
        },
        // getCurrentPoint() {
        //     abp.ajax.get('/api/services/app/PointAccount/GetCurrentPoint').then(res => {
        //         this.currrentMemberPoint = res.data.result;
        //     });
        // },
    },
    created() {
        // this.loading = true;
        this.id = parseInt(this.$route.params.id) || 0;
        if (this.id > 0) {
            this.getActiveDetail();
        }
    }
}
